import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** One in-app notification shown in the shared header bell. */
export interface AppNotification {
  id: string;
  /** The raw socket event name this came from (support-ticket-assigned, driver-approved, ...). */
  type: string;
  titleKey: string;
  titleParams?: Record<string, unknown>;
  bodyKey?: string;
  bodyParams?: Record<string, unknown>;
  route: string[];
  queryParams?: Record<string, unknown>;
  createdAt: Date;
  read: boolean;
}

/** What a single socket event is turned into, before id/createdAt/read/type are filled in. */
export type NotificationFactory = (data: any) => Omit<AppNotification, 'id' | 'createdAt' | 'read' | 'type'>;

/** Any AuthService satisfies this - same shape ChatAuthLike/SupportAuth already use. */
export interface NotificationAuthLike {
  getAccessToken(): string | null;
  isAuthenticated$: Observable<boolean>;
}

export interface NotificationConfig {
  /** Defaults to '/ws' (UnifiedWebSocketGateway), same as shared-chat. */
  socketUrl?: string;
  /** Socket event name -> how to turn its payload into a notification. Only listed events are surfaced. */
  events: Record<string, NotificationFactory>;
}

export const NOTIFICATION_AUTH = new InjectionToken<NotificationAuthLike>('NOTIFICATION_AUTH');
export const NOTIFICATION_CONFIG = new InjectionToken<NotificationConfig>('NOTIFICATION_CONFIG');
